import { Card, Col, Flex, Row, Timeline, Typography } from 'antd';
import React, { useEffect, useState } from 'react';
import StyledContainer from './StyledContainer';
import CertificatePopup from './CertificatePopup';
import { IconContext } from 'react-icons';
import { PiCertificateLight } from 'react-icons/pi';

const Education = ({ Data, i18 }) => {
  const [loading, setLoading] = useState(true);
  const education = Data.education.filter(i => i.display != false);
  const [modalVisible, setModalVisible] = useState(false);
  const [selectedCertificate, setSelectedCertificate] = useState(null);

  useEffect(() => {
    setLoading(false);
  }, []);

  const timelineItems = (page, size) => {
    const start = (page - 1) * size;
    const end = page * size
    return education.slice(start, end).map((item, index) => ({
      children: (
        <Row>
          <Col span={24}>
            <Typography.Text strong>{item.institution}</Typography.Text>
          </Col>
          <Col span={24}>
            <Typography.Text type="secondary">
              <button
                className='link-style'
                onClick={(e) => {
                  e.preventDefault();
                  setSelectedCertificate(item);
                  setModalVisible(true);
                }}
              >
                <React.Fragment>
                  <IconContext.Provider value={{ size: '1.5rem' }}>
                    <PiCertificateLight />
                  </IconContext.Provider>{' '}
                </React.Fragment>
              </button>
              {item.from} - {item.to}
            </Typography.Text>
          </Col>
          <Col span={24}>
            <Typography.Text>{item.degree}</Typography.Text>
          </Col>

          <Col span={24}>
            <Flex
              vertical
              gap={8}
            >
              {item.certificate?.map((subItem, idx) => (
                <div key={idx} >
                  <Typography.Text style={{ fontSize: "0.9rem", fontFamily: "Inconsolata", fontStyle: "italic" }}>
                    <strong>{subItem?.title}: </strong>
                    {subItem?.value}
                  </Typography.Text>
                </div>
              ))}
            </Flex>
          </Col>
        </Row>
      ),
      key: index,
    }))
  };

  return (
    <React.Fragment>
      <div className="section" id="education">
        <StyledContainer>
          <Row>
            <Col span={24}>
              <Typography.Title
                level={3}
                style={{ textAlign: 'center', marginBottom: '2rem' }}
              >
                {i18.TIT_EDUCATION}
              </Typography.Title>
            </Col>
            <Col span={24}>
              <Card
                loading={loading}
                style={{ cursor: 'default' }}
                hoverable
                variant="outlined"
                className="z-shadow"
              >
                <Row>
                  <Col xl={12}
                    lg={12}
                    md={12}
                    sm={24}
                    xs={24}>
                    <Typography.Title level={5} type="secondary" style={{ textAlign: 'center', marginTop: 16 }}>
                      {1}
                    </Typography.Title>
                    <Timeline items={timelineItems(1, 4)} />
                  </Col>
                  <Col xl={12}
                    lg={12}
                    md={12}
                    sm={24}
                    xs={24}>
                    <Typography.Title level={5} type="secondary" style={{ textAlign: 'center', marginTop: 16 }}>
                      {2}
                    </Typography.Title>
                    <Timeline items={timelineItems(2, 4)} />
                  </Col>
                </Row>
              </Card>
            </Col>
          </Row>
        </StyledContainer>
      </div>
      {modalVisible && (
        <CertificatePopup
          title={selectedCertificate ? selectedCertificate.title : ''}
          educationItem={selectedCertificate}
          visible={modalVisible}
          handleCancel={() => {
            setModalVisible(false);
          }}
        />
      )}
    </React.Fragment>
  );
};

export default Education;
